import Vue from 'vue';

export default [
    {
        pathId: 'ogs',
        component: 'org-settings',
        title: 'Organization Settings',
        icon: 'fa-building-user',
        size: 'md', //sm, md, lg, xl
    },{
        pathId: 'ogun',
        component: 'new-org-user',
        title: 'New User',
        icon: 'fa-plus',
        size: 'md',
        loading: true
    }, {
        pathId: 'ogue',
        component: 'edit-org-user',
        title: 'Edit User',
        icon: 'fa-pencil',
        size: 'md',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'ogp',
        component: 'org-payout',
        title: 'Manage Payout',
        icon: 'fa-money-check-dollar-penpencil',
        size: 'md',
        loading: true
    }, {
        pathId: 'ogua',
        component: 'portal-user-activity',
        title: 'Portal User Activity',
        icon: 'fa-chart-line',
        size: 'lg',
        loading: true,
        props: ['portalUserId']
    }
];

Vue.component('org-settings', () => import('@/cards/organization/OrgSettings'));
Vue.component('new-org-user', () => import('@/cards/organization/NewUser'));
Vue.component('edit-org-user', () => import('@/cards/organization/EditUser'));
Vue.component('org-payout', () => import('@/cards/organization/Payout'));
Vue.component('portal-user-activity', () => import('@/cards/organization/PortalUserActivity'));
